<template>
	<v-list two-line class="transparent py-0">
		<v-list-tile avatar v-if="item.avatar" download>
			<v-list-tile-avatar class="media-avatar">
				<img v-bind:src="item.avatar">
			</v-list-tile-avatar>
			<v-list-tile-content>
				<v-list-tile-title class="media-title">
					<h5 class="semibold-blue-title-30">{{ item.title }}</h5>
				</v-list-tile-title>
				<v-list-tile-sub-title>
					<span v-for="subtitle in item.subtitles" :key="subtitle.key">
						<span class="subtitle-key">{{ subtitle.key }}:</span>
						<span class="subtitle-value">{{ subtitle.value }}</span>
					</span>
				</v-list-tile-sub-title>
			</v-list-tile-content>
		</v-list-tile>
	</v-list>
</template>

<script>
export default {
	name: 'media',
	props: {
		item: {
			type: Object,
			required: true,
		},
	},
};
</script>

<style lang="scss" scoped>
	.media-title {
		height: auto;
	}

	.media-avatar {
		padding-top: 0px !important;

		img {
			height: 47px !important;
			width: 47px !important;
		}
	}

	.subtitle-key {
		color: map-get($colors, default-dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($fonts, fifteen);
	}

	.subtitle-value {
		color: map-get($colors, default-skyblue);
		padding-left: 5px;
		padding-right: 26px;
	}
</style>




// WEBPACK FOOTER //
// Media.vue?328586de